import React, {useState} from "react";
import { Card, CardBody, Container, Row } from "reactstrap";
// import { ToastContainer } from "react-toastify";
import TokenCalender from "../../../Components/Applications/Calendar/TokenCalender";
import BookedTokens from "../../../Components/Applications/Calendar/BookedTokens";
import Appointment from "../../../Components/Applications/Calendar/Appointment";

export default function MedicalRepCalendar() {
  const [refreshTokens, setRefreshTokens] = useState(0);

  return (
    <Container className="calendar-basic" fluid>
      <Card>
        <CardBody>
          <Row>
            {/* <ToastContainer position="top-center" autoClose={3000} /> */}
            {/* <TokenCalender onBookingSuccess={() => setRefreshTokens(prev => prev + 1)} /> */}
            <Appointment  onBookingSuccess={() => setRefreshTokens(prev => prev + 1)}/>
           
            <BookedTokens key={refreshTokens} />
          </Row>
        </CardBody>
      </Card>
    </Container>
  );
}

